<template>
    <div class="animated fadeIn">
        <b-card>
            <h5 class="mb-0"><i class="fa fa-fw fa-book mr-2" />Laporan</h5>
            <hr />
            <b-row>
                <b-col md="4">
                    <b-form-group label="Tgl. Mulai Laporan">
                        <b-form-input type="date" v-model="input.start" />
                    </b-form-group>
                </b-col>
                <b-col md="4">
                    <b-form-group label="Tgl. Akhir Laporan">
                        <b-form-input type="date" v-model="input.end" />
                    </b-form-group>
                </b-col>
            </b-row>
            <div>
                <b-button variant="dark" class="mr-2 mb-2" @click="generateReportSales">
                    <i class="fa fa-download mr-2" />Laporan Sales & Retur Barang
                </b-button>
                <b-button variant="dark" class="mr-2 mb-2" @click="generateReportTransaction">
                    <i class="fa fa-download mr-2" />Laporan Transaksi Customer
                </b-button>
                <b-button variant="dark" class="mr-2 mb-2" @click="generateDeliveryReport">
                    <i class="fa fa-download mr-2" />Laporan Penerimaan Barang
                </b-button>
                <b-button variant="dark" class="mr-2 mb-2" @click="generateMovementReport">
                    <i class="fa fa-download mr-2" />Laporan Perpindahan Barang
                </b-button>
                <b-button variant="dark" class="mr-2 mb-2" @click="generateCatalogCustomerLoginReport">
                    <i class="fa fa-download mr-2" />Laporan Catalog Customer
                </b-button>
                <b-button variant="dark" class="mr-2 mb-2" @click="generateAdminTaskCountReport">
                    <i class="fa fa-download mr-2" />Laporan Tugas Admin
                </b-button>
                <b-button variant="dark" class="mr-2 mb-2" @click="generateInventoryReturnReport">
                    <i class="fa fa-download mr-2" /> Laporan Kirim Balik PGI
                </b-button>
                <b-button variant="dark" class="mr-2 mb-2" @click="generateInventoryExternal">
                    <i class="fa fa-download mr-2" /> Laporan Penerimaan Barang External
                </b-button>
            </div>
        </b-card>
        <b-modal id="m-download" :title="modalTitle" centered no-close-on-backdrop no-close-on-esc hide-footer>
            <div v-if="status == 0">
                Menyiapkan laporan, mohon menunggu...
            </div>
            <div v-else-if="status == -1">
                Gagal menyiapkan laporan. Silahkan coba lagi, atau perpendek jarak antara tanggal mulai dan selesai
                laporan!
            </div>
            <div v-else>
                Laporan sudah siap. Tekan tombol dibawah ini untuk download laporan Excel.
                <div class="mt-2">
                    <a :href="$BASE_FILE_PATH + path" download>
                        <b-button variant="primary">
                            <i class="fa fa-download mr-2" />Download Excel Laporan
                        </b-button>
                    </a>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    data() {
        return {

            status: 1, // 1: sukses, 0: loading, -1: error
            path: "",
            modalTitle: "",

            input: {
                start: "",
                end: ""
            }

        }
    },
    methods: {

        generateReportSales() {

            this.modalTitle = "Laporan Sales"

            if (this.input.start == "" || this.input.end == "") {
                return this.$helper.toastError(this, "Mohon lengkapi tanggal mulai dan akhir laporan!")
            }

            let payload = {
                start: this.input.start,
                end: this.input.end
            }

            this.$bvModal.show("m-download")
            this.status = 0
            this.$axios.post("report/sales", payload, { timeout: 600000 }).then(res => {

                this.status = 1
                this.path = res.data.data.path

            })
                .catch(error => {
                    this.status = -1
                    this.$helper.parseError(this, error)
                })

        },

        generateReportReturn() {

            this.modalTitle = "Laporan Retur Barang"

            if (this.input.start == "" || this.input.end == "") {
                return this.$helper.toastError(this, "Mohon lengkapi tanggal mulai dan akhir laporan!")
            }

            let payload = {
                start: this.input.start,
                end: this.input.end
            }

            this.$bvModal.show("m-download")
            this.status = 0
            this.$axios.post("report/return", payload, { timeout: 600000 }).then(res => {

                this.status = 1
                this.path = res.data.data.path

            })
                .catch(error => {
                    this.status = -1
                    this.$helper.parseError(this, error)
                })

        },

        generateReportTransaction() {

            this.modalTitle = "Laporan Transaksi Customer"

            if (this.input.start == "" || this.input.end == "") {
                return this.$helper.toastError(this, "Mohon lengkapi tanggal mulai dan akhir laporan!")
            }

            let payload = {
                start: this.input.start,
                end: this.input.end
            }

            this.$bvModal.show("m-download")
            this.status = 0
            this.$axios.post("report/transactions", payload, { timeout: 600000 }).then(res => {

                this.status = 1
                this.path = res.data.data.path

            })
                .catch(error => {
                    this.status = -1
                    this.$helper.parseError(this, error)
                })

        },

        generateDeliveryReport() {

            this.modalTitle = "Laporan Penerimaan Barang"

            if (this.input.start == "" || this.input.end == "") {
                return this.$helper.toastError(this, "Mohon lengkapi tanggal mulai dan akhir laporan!")
            }

            let payload = {
                start: this.input.start,
                end: this.input.end
            }

            this.$bvModal.show("m-download")
            this.status = 0
            this.$axios.post("report/delivery", payload, { timeout: 600000 }).then(res => {

                this.status = 1
                this.path = res.data.data.path

            })
                .catch(error => {
                    this.status = -1
                    this.$helper.parseError(this, error)
                })

        },

        generateMovementReport() {

            this.modalTitle = "Laporan Perpindahan Barang"

            if (this.input.start == "" || this.input.end == "") {
                return this.$helper.toastError(this, "Mohon lengkapi tanggal mulai dan akhir laporan!")
            }

            let payload = {
                start: this.input.start,
                end: this.input.end
            }

            this.$bvModal.show("m-download")
            this.status = 0
            this.$axios.post("report/movement", payload, { timeout: 600000 }).then(res => {

                this.status = 1
                this.path = res.data.data.path

            })
                .catch(error => {
                    this.status = -1
                    this.$helper.parseError(this, error)
                })

        },

        generateCatalogCustomerLoginReport() {

            this.modalTitle = "Laporan Catalog Customer"

            if (this.input.start == "" || this.input.end == "") {
                return this.$helper.toastError(this, "Mohon lengkapi tanggal mulai dan akhir laporan!")
            }

            let payload = {
                start: this.input.start,
                end: this.input.end
            }

            this.$bvModal.show("m-download")
            this.status = 0
            this.$axios.post("report/catalog-customer", payload, { timeout: 600000 }).then(res => {

                this.status = 1
                this.path = res.data.data.path

            })
                .catch(error => {
                    this.status = -1
                    this.$helper.parseError(this, error)
                })

        },

        generateAdminTaskCountReport() {

            this.modalTitle = "Laporan Tugas Admin"

            if (this.input.start == "" || this.input.end == "") {
                return this.$helper.toastError(this, "Mohon lengkapi tanggal mulai dan akhir laporan!")
            }

            let payload = {
                start: this.input.start,
                end: this.input.end
            }

            this.$bvModal.show("m-download")
            this.status = 0
            this.$axios.post("report/admin-task", payload, { timeout: 600000 }).then(res => {

                this.status = 1
                this.path = res.data.data.path

            })
                .catch(error => {
                    this.status = -1
                    this.$helper.parseError(this, error)
                })

        },

        generateInventoryReturnReport() {

            this.modalTitle = "Laporan Kirim Balik PGI"

            if (this.input.start == "" || this.input.end == "") {
                return this.$helper.toastError(this, "Mohon lengkapi tanggal mulai dan akhir laporan!")
            }

            let payload = {
                start: this.input.start,
                end: this.input.end
            }

            this.$bvModal.show("m-download")
            this.status = 0
            this.$axios.post("report/inventory-return", payload, { timeout: 600000 }).then(res => {

                this.status = 1
                this.path = res.data.data.path

            })
                .catch(error => {
                    this.status = -1
                    this.$helper.parseError(this, error)
                })

        },

        generateInventoryExternal() {

            this.modalTitle = "Laporan Penerimaan Barang External"

            if (this.input.start == "" || this.input.end == "") {
                return this.$helper.toastError(this, "Mohon lengkapi tanggal mulai dan akhir laporan!")
            }

            let payload = {
                start: this.input.start,
                end: this.input.end,
                type_report : "EXT"
            }

            this.$bvModal.show("m-download")
            this.status = 0
            this.$axios.post("report/delivery", payload, { timeout: 600000 }).then(res => {

                this.status = 1
                this.path = res.data.data.path

            })
                .catch(error => {
                    this.status = -1
                    this.$helper.parseError(this, error)
                })

        }
    }
}
</script>
